import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { ScrollProvider } from "./pages/context/ScrollContext";
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import store from './pages/redux/store';
import { persistStore } from 'redux-persist';
let persistor = persistStore(store);
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ScrollProvider>
      <Provider store={store}>
        <PersistGate persistor={persistor}></PersistGate>
        <App />
      </Provider>
    </ScrollProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
